import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/header';
import JobMenu from '../components/jobs/jobmenu';
import PageMenu from '../components/pagemenu';
import ErrorBoundary from '../components/ErrorBoundary';
import { logComponent, logDiagnostic } from '../utils/diagnosticLogger';

import './jobs.css';

import JobArchived from '../components/jobs/jobarchived';
import JobList from '../components/jobs/joblist';

function Jobs() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeComponent, setActiveComponent] = useState('workOrderList');
  const prevActiveComponent = React.useRef('workOrderList');

  useEffect(() => {
    logComponent('Jobs', 'mount', {
      pathname: window.location.pathname,
      hash: window.location.hash,
      search: window.location.search,
      navigationType: performance.getEntriesByType('navigation')[0]?.type || 'unknown'
    });
    
    // Check for auth token in localStorage on component mount
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
    
    return () => {
      logComponent('Jobs', 'unmount', {
        activeComponent,
        isAuthenticated,
        reason: 'component-unmounting'
      });
    };
  }, []);
  
  useEffect(() => {
    // Only log if component actually changed
    if (prevActiveComponent.current !== activeComponent) {
      logComponent('Jobs', 'activeComponent-change', {
        from: prevActiveComponent.current,
        to: activeComponent,
        timestamp: Date.now()
      });
      prevActiveComponent.current = activeComponent;
    }
  }, [activeComponent]);
  
  // Detect if Jobs component is remounting unexpectedly (full page reload)
  useEffect(() => {
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    if (navigationEntry && navigationEntry.type === 'reload') {
      logDiagnostic('page', 'full-page-reload-detected-in-jobs', {
        pathname: window.location.pathname,
        activeComponent,
        navigationType: navigationEntry.type,
        timestamp: Date.now()
      });
    }
  }, []);


  return (
    <div className="App">
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      {isAuthenticated ? (
        <ErrorBoundary>
          <div className='content'>
            <JobMenu setActiveComponent={setActiveComponent} />
            {activeComponent === 'workOrderList' && (
              <ErrorBoundary>
                <JobList />
              </ErrorBoundary>
            )}
            {activeComponent === 'archived' && (
              <ErrorBoundary>
                <JobArchived />
              </ErrorBoundary>
            )}
          </div>
        </ErrorBoundary>
      ) : (
        <div>Please log in to view content</div>
      )}
      {/* Bottom navigation for mobile */}
      <PageMenu className="bottom-nav" />
    </div>
  );
}

export default Jobs;